// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"576":"6f3dba1d","804":"ba92b96a","835":"cbff2416"}[chunkId] + ".chunk.js";
};